
import AppSearchBrowse from "@/components/browse/SearchBrowse.vue";
import { Sale } from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { SaleService } from "@/services/sale-service";
import { IBrowseBaseDataSource } from "@/utils/browse/browse-data-source";
import { HumanFilter } from "@/utils/human-filter";
import Vue from "vue";
import { BookYearService } from "@/services/book-year-service";
import AppSelectBookYear from "@/components/bookyear/SelectBookYear.vue";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { IQueryParams } from "@/utils/query-params";
import { IGetResponse } from "@/utils/get-response";
import {CrmService, UserConfigService} from "@/services";

export default Vue.extend({
	data(){
		return{
			refresh: 0,
			selectedBookYear: `${BookYearService.selectedBookYear}`,
			selectedItems: [] as Sale[],
			buttonDisabled: false,
			crmFilterActive: true,
			generalSettings: UserConfigService.getGeneralSettings()
		};
	},
	props: {
		contactId: {
			type: Number,
			default: 0
		},
		crmId: {
			type: Number,
			default: 0
		},
		filterOpen: {
			type: Boolean,
			default: false
		},
		bookYearSelect: {
			type: Boolean,
			default: false
		},
		clearViewSettingsFilters: Boolean,
		overrideStaticViewSelect: Boolean,
		allowViewButton: Boolean,
		view: Object as ()=>View,
		multiple: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		filterOnCrmId():string{
			return this.crmFilterActive ? this.$ct("show-all-sales").toString() : this.$ct("show-crm-sales").toString();
		},
		extraFilters():HumanFilter[]{
			let result = [];
			if (this.contactId != 0){
				let filter = new HumanFilter();
				filter.Field = "this.ContactID";
				filter.Operator = "=";
				filter.Values = [`${this.contactId}`];
				result.push(filter);
			}
			if (this.crmId != 0 && this.crmFilterActive){
				let filter = new HumanFilter();
				filter.Field = "this.CrmID";
				filter.Operator = "=";
				filter.Values = [`${this.crmId}`];
				result.push(filter);
			}
			return result;
		},
		dataSource():IBrowseBaseDataSource<Sale> {
			let t = this;
			return {
				getSettings: () => BrowseService.getBrowse(6),
				getElements: (params)=>SaleService.getSales(params, t.selectedBookYear, this.extraFilters),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return SaleService.getTotals(view);
				},
				browseName: "Sales",
				modelName: "Sale",
				info(s:Sale){
					t.$router.push(`/sales/info/${s.ID}`);
				},
				staticViewGetElements(view:View, params:IQueryParams):Promise<IGetResponse<any>>{
					return SaleService.getSalesStaticView(view, params, "", t.extraFilters);
				}
			};
		}
	},
	watch: {
		selectedItems(){
			this.$emit("select", this.selectedItems);
		}
	},
	methods: {
		onClick(sale:Sale) {
			this.$emit("click", sale);
		},
		onMultiple() {
			this.buttonDisabled = true;
			this.$emit("multiple", this.selectedItems);
		},
		onBookYearChange(bookyear:string) {
			this.selectedBookYear = bookyear;
			let browse = this.$refs.browse as any;
			if (!browse) return;
			browse.refresh();
		},
		onSelectChanged(selected: Sale[]){
			this.selectedItems = selected;
		},
		async createSaleEvent(){

			if(this.selectedItems.length<=0)
				return;

			await CrmService.linkSaleToCrm(this.crmId,this.selectedItems[0].ID);
			this.$emit("close-update");
		}
	},
	components: {
		AppSearchBrowse,
		AppSelectBookYear
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
